import { UserDataStore } from '@/store/user-store/user-data.store';
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { startWith, filter, take, map } from 'rxjs';

export const storeGuard: CanActivateFn = () => {
  const userStore = inject(UserDataStore);
  const router = inject(Router);
  return toObservable(userStore.isLoaded).pipe(
    startWith(userStore.isLoaded()),
    filter(Boolean),
    take(1),
    map(() => {
      return userStore.isRetailSpot() ? true : router.createUrlTree(['/portal/home']);
    }),
  );
};
